

export const FETCH_NFT_COLLECTION = "FETCH_NFT_COLLECTION";
export const FETCH_NFT_COLLECTION_SUCCESS = "FETCH_NFT_COLLECTION_SUCCESS";
export const FETCH_NFT_COLLECTION_FAILURE = "FETCH_NFT_COLLECTION_FAILURE";

export const SEARCH_NFT_COLLECTION = "SEARCH_NFT_COLLECTION";
export const SEARCH_NFT_COLLECTION_SUCCESS = "SEARCH_NFT_COLLECTION_SUCCESS";
export const SEARCH_NFT_COLLECTION_FAILURE = "SEARCH_NFT_COLLECTION_FAILURE";

export const FILTER_SEARCH_NFT_COLLECTION = "FILTER_SEARCH_NFT_COLLECTION";
export const FILTER_SEARCH_NFT_COLLECTION_SUCCESS = "FILTER_SEARCH_NFT_COLLECTION_SUCCESS";
export const FILTER_SEARCH_NFT_COLLECTION_FAILURE = "FILTER_SEARCH_NFT_COLLECTION_FAILURE";

export const FILTER_NFT_BY_TAGS = "FILTER_NFT_BY_TAGS"
export const FILTER_NFT_BY_TAGS_SUCCESS = "FILTER_NFT_BY_TAGS_SUCCESS"
export const FILTER_NFT_BY_TAGS_FAILURE = "FILTER_NFT_BY_TAGS_FAILURE"



export const SORT_BY_PRICE = "SORT_BY_PRICE"
export const SORT_BY_PRICE_SUCCESS = "SORT_BY_PRICE_SUCCESS"
export const SORT_BY_PRICE_FAILURE = "SORT_BY_PRICE_FAILURE"